import type { FilterNames } from "app/custom-hooks/useSubtitleFilters";

export const STATIC_TABLE_PROPS = {
    // we need to use pageSize > competitorsCount to hide the pagination controls
    pagination: { pageSize: 50 },
    tableLayout: "auto" as const,
};

export const SUBTITLE_FILTERS: FilterNames[] = ["date", "webSource", "country"];
